import React from 'react'
import { makeStyles, Fab } from '@material-ui/core'
import { Icon } from 'packages/eid-icons'

const useStyles = makeStyles((theme) => ({
    root: (props) => ({
        margin: theme.spacing(1),
        textTransform: 'capitalize',
        fontSize: '14px',
        height: '31px !important',
        color: '#ff5e65 !important',
        backgroundColor: '#ffffff !important',
        border: '1px solid #ff5e65',
        boxShadow: 'none',
        margin: 0,
        minWidth: '80px !important',

        '&:hover': {
            color: '#ffffff !important',
            backgroundColor: '#ff5e65 !important',
            borderColor: 'transparent !important',
            '& svg': {
                color: '#ffffff !important',
            },
        },
        ...props.styles,
    }),
    icon: {
        marginLeft: 6,
        color: '#ff5e65',
    },
}))
const DeleteButton = ({ color, styles, children, ...rest }) => {
    const classes = useStyles({ color, styles })
    return (
        <Fab variant="extended" size="small" className={classes.root} {...rest}>
            {children}
            <Icon
                name="Close"
                className={classes.icon}
                width="8px"
                height="8px"
            ></Icon>
        </Fab>
    )
}

export default DeleteButton
